import { render, staticRenderFns } from "./DevToolAfasBuildings.vue?vue&type=template&id=90e31094"
import script from "./DevToolAfasBuildings.vue?vue&type=script&lang=ts"
export * from "./DevToolAfasBuildings.vue?vue&type=script&lang=ts"
import style0 from "./DevToolAfasBuildings.vue?vue&type=style&index=0&id=90e31094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports